<template>
  <main>
    <div class="container-fluid message page-note">
      <TopTemplate>
        <template #left-element>
          <div>
            <h3>{{ $t("common.domainList") }}</h3>
            <p class="mb-0">Classe : {{ className }}</p>
          </div>
        </template>
        <template v-slot:right-element>
          <div class="d-flex">
            <router-link :to="{name: 'BulletinNotes'}" class="btn btn-outline-primary button margin-r" :disabled="loading">
              <i class="arrow left"></i>
              {{ $t("button.retour") }}
            </router-link>
            <div v-if="disabledGeneration" class="spinner-border text-info spinner-bulletin" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <button v-if="generateBtn && classObject.school_year_status" class="btn button btn-primary margin-r" @click="generateBulletin" :disabled="disabledGeneration">
              {{ $t("common.generateBulletin") }}
            </button>
            <router-link v-if="classId" class="btn button btn-primary" :to="{name: 'bulletinsList', params: {id: classId}}" :disabled="loading">
              {{ $t("common.seeBulletin") }}
            </router-link>
          </div>
        </template>
      </TopTemplate>
      <nav class="mb-2">
        <div class="nav nav-tabs list-nav-pay" id="nav-tab" role="tablist">
          <button
            v-for="(tab, index) in tabs"
            :key="index"
            class="nav-link"
            :class="{active: currentTab === tab.id}"
            :id="'nav-' + tab.id + '-tab'"
            data-bs-toggle="tab"
            :data-bs-target="'#nav-' + tab.id"
            type="button"
            role="tab"
            :aria-controls="'nav-' + tab.id"
            :aria-selected="currentTab === tab.id"
            @click="changeTab(tab.id, tab.period)"
          >
            {{ tab.label }}
          </button>
        </div>
        <div class="content-tabs">
          <!-- <div v-for="(tab, index) in tabs" :key="index" class="tab-pane fade" :class="{active: currentTab === tab.id}" :id="'nav-' + tab.id" role="tabpanel"></div> -->
        </div>
      </nav>

      <div v-if="loading" class="card mt-2 text-center d-block pt-2 pb-24">
        <div class="spinner-border text-info" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <div class="table teacher table-note" v-if="!loading && domainList.length > 0">
        <div class>
          <div class="row">
            <div class="col-md-12">
              <div class="table__wrapper table-responsive-vertical table-responsive">
                <table class="table">
                  <thead>
                    <tr class="row">
                      <th class="col-md-3">{{ $t("common.category") }}</th>
                      <th class="col-md-3">{{ $t("notes.tab.update") }}</th>
                      <th class="col-md-3">{{ $t("notes.tab.statut") }}</th>
                      <th class="col-md-3 view">{{ $t("common.action") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="ele in domainList" :key="ele.id + 'class'" class="row">
                      <td class="col-md-3">
                        <p class="classe-title">{{ ele.field ? ele.field.name_fr : "-" }}</p>
                      </td>
                      <td class="col-md-3">
                        <p>{{ dateTime(ele.updated_at) }}</p>
                      </td>
                      <td class="col-md-3">
                        <div class="badge-statut" :class="[ele.class_field_status == 3 ? 'validated' : 'no-validated']">
                          <p :class="[ele.class_field_status == 3 ? 'validated' : 'no-validated']">{{ translateStatus(ele.class_field_status) }}</p>
                        </div>
                      </td>
                      <td class="col-md-3 action">
                        <div class="block-action">
                          <router-link
                            class="success_msg name_propre"
                            :to="{
                              name: 'NotesExamen',
                              params: {id: ele.id},
                            }"
                          >
                            <i class="icon-eyes green-color">
                              <span class="tooltiptext">{{ $t("button.tooltip.details") }}</span>
                            </i>
                          </router-link>
                          <router-link
                            v-if="ele.school_session.status"
                            :to="{
                              name: 'EditNotesExamen',
                              params: {id: ele.id},
                            }"
                            class
                          >
                            <i class="icon-edit-02 orange-color">
                              <span class="tooltiptext">{{ $t("button.tooltip.update") }}</span>
                            </i>
                          </router-link>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="!loading && !domainList.length" class="block-no-data">
        <p>{{ $t("common.noData") }}</p>
      </div>
    </div>
  </main>
</template>

<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import NoteService from "../../services/note.service";
import vSelect from "vue-select";
import moment from "moment";

export default {
  components: {
    TopTemplate,
    "v-select": vSelect,
  },
  setup() {
    return {};
  },
  data() {
    return {
      loading: false,
      domainList: [],
      currentTab: "trimestre1",
      tabs: [
        {id: "trimestre1", label: "Trimestre 1", period: 1},
        {id: "trimestre2", label: "Trimestre 2", period: 2},
        {id: "trimestre3", label: "Trimestre 3", period: 3},
      ],
      id: null,
      className: "",
      classId: null,
      periodId: 1,
      periodName: "",
      classFieldsIds: [],
      optionalFieldsIds: [],
      schoolSessionId: null,
      disabledGeneration: false,
      generateBtn: false,
      classObject: {},
    };
  },
  computed: {},
  mounted() {
    this.id = this.$route.params.id;
    this.defaultTabActive();
  },
  methods: {
    changeTab(tabId, period) {
      this.currentTab = tabId;
      this.periodId = period;
      this.periodName = this.tabs.find((element) => element.period == this.periodId)?.label;
      this.getDomainList(this.id, period);
    },
    async generateBulletin() {
      this.disabledGeneration = true;
      const Swal = require("sweetalert2");
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-confirm  btn-primary",
          cancelButton: "btn  btn-cancel  btn-outline-primary",
        },
        buttonsStyling: false,
        showCloseButton: true,
      });
      const data = {
        class_id: this.classId,
        period_id: this.periodId,
        school_session_id: this.schoolSessionId,
        class_fields: this.classFieldsIds,
        optional_fields: this.optionalFieldsIds,
      };
      try {
        const result = await swalWithBootstrapButtons.fire({
          html: `<img src="/images/hourglass-fill-orange.svg" style="width:35px;color:#EB690B"></img> <br> <h2 style="font-size: 14px;font-weight: 600;"> ${this.$t(
            "common.confirmGenerateBulletin",
            {
              period: this.periodName,
              class: this.className,
            }
          )} </h2> <p style="font-size:12px;font-style:italic;font-weight:600;margin-bottom: 0;">${this.$t("common.infosAboutGeneration")}</p>`,
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: this.$t("common.deletIT"),
          cancelButtonText: this.$t("common.noCancel"),
          reverseButtons: true,
        });
        if (result.isConfirmed) {
          await NoteService.generateBulletinPdf(data);
        }
      } catch (error) {
        console.error("eror : ", error);
      } finally {
        this.disabledGeneration = false;
      }
    },
    defaultTabActive() {
      const tabId = this.$store.getters.getPeriodId;
      const defaultTab = this.tabs.find((element) => element.period === tabId);
      this.currentTab = defaultTab ? defaultTab.id : "trimestre1";
      this.periodId = tabId || 1;
      this.periodName = defaultTab ? defaultTab.label : "Trimestre 1";
      this.getDomainList(this.id, this.periodId);
    },
    async getDomainList(id, period_id) {
      try {
        this.loading = true;
        const config = {
          params: {
            class_id: id,
            period_id: period_id,
          },
        };
        const res = await NoteService.getDomainList(config);
        this.domainList = res.data.data;
        this.classObject = res.data;
        this.className = this.classObject.class_name;
        this.classId = this.classObject.class_id;
        this.schoolSessionId = this.classObject.school_year_id;
        this.generateBtn = this.domainList.length ? this.domainList.filter((ele) => ele.additional_field === 0).every((ele) => ele.class_field_status === 3) : false;
        this.classFieldsIds = [];
        this.optionalFieldsIds = [];

        this.domainList.forEach((ele) => {
          if (ele.additional_field === 0) {
            this.classFieldsIds.push(ele.id);
          } else if (ele.additional_field === 1 && ele.class_field_status == 3) {
            this.optionalFieldsIds.push(ele.id);
          }
        });
      } catch (err) {
        console.error("error : ", err);
      } finally {
        this.loading = false;
      }
    },
    dateTime(value) {
      return moment(value).locale("fr").format("DD/MM/YYYY");
    },
    translateStatus(statusId) {
      switch (statusId) {
        case 1:
          return this.$t("statut.in_progress");
        case 2:
          return this.$t("statut.invalid");
        default:
          return this.$t("statut.validated");
      }
    },
  },
  beforeUnmount() {
    this.$store.commit("SET_PERIOD_ID", null);
  },
};
</script>

<style lang="scss" scoped>
.spinner-bulletin {
  height: 20px;
  margin-top: 8px;
  width: 20px;
  margin-right: 4px;
}
</style>
